import { inject, Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ToastService, ToastType, ToastData } from '@hglobal/common';

@Injectable({ providedIn: 'root' })
export class ToastI18nService {
  readonly #toastService = inject(ToastService);
  readonly #translateService = inject(TranslateService);

  showSuccess(messageKey: string, titleKey?: string): void {
    this.show(ToastType.Success, messageKey, titleKey);
  }

  showWarning(messageKey: string, titleKey?: string): void {
    this.show(ToastType.Warning, messageKey, titleKey);
  }

  showError(messageKey: string, titleKey?: string): void {
    this.show(ToastType.Error, messageKey, titleKey);
  }

  show(type: ToastType, messageKey: string, titleKey?: string, options: ToastData = {}): void {
    this.#toastService.show({
      type, message: this.#translateService.instant(messageKey),
      ...(titleKey ? { title: this.#translateService.instant(titleKey) } : {}),
      ...options,
    });
  }
}
